export default __webpack_public_path__ + "media/images/logo-symbol-icon-f4b2fef5db53a39ace2410501fcbf8b9.svg";